import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import ConfirmButton from '../ConfirmButton';
import { selectPassing } from './selectors';
import { pass } from './actions';
import { selectIsMainPhase, selectOptions } from '../ActiveGame/selectors';
import { optionReason } from '../ActiveGame/options';

/** Ends the turn without attacking. */
const PassButton = ({ userId }) => {
  const dispatch = useDispatch();
  const isMainPhase = useSelector((state) => selectIsMainPhase(state, { userId }));
  const passing = useSelector(selectPassing);
  const options = useSelector(selectOptions);

  if (!isMainPhase) {
    return null;
  }

  return (
    <ConfirmButton
      onConfirm={() => dispatch(pass())}
      disabled={passing || !!optionReason(options && options.get('pass'))}
      prompt="End your turn without attacking?"
      confirmLabel="End turn"
    >
      End turn
    </ConfirmButton>
  );
};

PassButton.propTypes = {
  userId: PropTypes.number.isRequired,
};

export default PassButton;
